// Display name for the user behind a history field (advancePayments.createdBy /
// lastUpdatedBy, quotedValue.changedBy). The lead API populates these into
// { _id, firstName, lastName, userName }; a bare id (not populated) falls back
// to agentMap, which only holds sales agents.
export const getActorName = (actor, agentMap = {}) => {
    if (!actor) return null;

    if (typeof actor === 'object') {
        const fullName = [actor.firstName, actor.lastName].filter(Boolean).join(' ').trim();
        return fullName || actor.fullName || actor.name || actor.userName || agentMap[actor._id] || null;
    }

    return agentMap[actor] || null;
};

export const getActorId = (actor) => {
    if (!actor) return null;
    const id = typeof actor === 'object' ? actor._id || actor.id : actor;
    return id ? String(id) : null;
};
